import { useState } from "react";
import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { SectionHead, Reveal, EASE } from "./Reveal";
import { LENS } from "../content";

export const Lens = () => {
  const [open, setOpen] = useState(0);
  return (
    <section id="lens" className="relative py-28 md:py-40" data-testid="lens-section">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-16 px-5 sm:px-8 lg:grid-cols-12 lg:px-12">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <SectionHead
              index="05"
              label="Our leadership lens"
              title={<>Talent who can <em className="text-emerald-400">deliver,</em> not just fit.</>}
              sub="Every shortlisted leader is assessed against five dimensions, calibrated to your business, your regulator and your culture."
            />
            <Reveal delay={0.2}>
              <p className="font-display mt-12 border-l-2 border-emerald-400 pl-6 text-2xl sm:text-3xl italic leading-snug text-zinc-200">
                Right people don't just fill roles. They build what's next.
              </p>
            </Reveal>
          </div>
        </div>
        <div className="lg:col-span-7 border-t border-white/10">
          {LENS.map((l, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={l.t} delay={i * 0.06}>
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  onMouseEnter={() => setOpen(i)}
                  className="group block w-full border-b border-white/10 py-8 text-left"
                  data-testid={`lens-item-${i}`}
                  aria-expanded={isOpen}
                >
                  <div className="flex items-center gap-6 sm:gap-10">
                    <span className={`font-display text-5xl sm:text-7xl leading-none transition-colors duration-500 ${isOpen ? "text-emerald-400" : "text-zinc-600"}`}>
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="font-display flex-1 text-2xl sm:text-4xl text-zinc-100">{l.t}</span>
                    <motion.span animate={{ rotate: isOpen ? 45 : 0 }} transition={{ duration: 0.4, ease: EASE }}>
                      <Plus className="h-6 w-6 text-zinc-400" />
                    </motion.span>
                  </div>
                  <motion.div
                    initial={false}
                    animate={{ height: isOpen ? "auto" : 0, opacity: isOpen ? 1 : 0 }}
                    transition={{ duration: 0.5, ease: EASE }}
                    className="overflow-hidden"
                  >
                    <p className="pt-5 pl-[4.5rem] sm:pl-[7.5rem] max-w-xl text-zinc-400 leading-relaxed">{l.d}</p>
                  </motion.div>
                </button>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
